import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row">
      <div className="relative lg:w-1/2 h-[300px] md:h-[400px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20illustration%2C%20a%20determined%20female%20character%20in%20elegant%20attire%20with%20flowing%20hair%2C%20dramatic%20lighting%20from%20side%2C%20warm%20cream%20and%20rose%20gold%20color%20palette%2C%20soft%20atmospheric%20background%2C%20clean%20composition%2C%20beautiful%20detailed%20anime%20manhwa%20art%20style&width=960&height=600&seq=cta-left-visual&orientation=landscape"
          alt="韩漫画网 - 开始你的漫画之旅"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent"></div>
        <div className="absolute bottom-6 left-6 md:bottom-10 md:left-10">
          <p className="text-xs text-background-50/70 mb-2 tracking-wider">每日更新</p>
          <h3 className="text-xl md:text-3xl font-bold font-heading text-background-50 leading-tight">
            最新韩漫
            <br />
            每日准时更新
          </h3>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-100 flex items-center justify-center px-6 md:px-12 py-12 md:py-16">
        <div className="max-w-md text-center">
          <h3 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 leading-tight">
            随时随地
            <br />
            畅享韩漫世界
          </h3>
          <p className="text-sm text-foreground-600 mt-4 leading-relaxed">
            无论你是在通勤路上、午休时间，还是周末宅家，韩漫画网随时随地为你提供最优质的韩国漫画阅读体验。手机、平板、电脑全平台支持，让你不会错过任何精彩内容。
          </p>
          <Link
            to="/category/action"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-7 py-3 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer mt-6"
          >
            开始免费阅读
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}